<template>
    <form class="home-form">
        <div class="input-group">
            <div class="input-wrapper-lg">
                <label for="buy-now-friend-name">Your Name</label>
                <input id="buy-now-friend-name" type="text" v-model.lazy="$v.name.$model" :class="validationStatus($v.name)">
            </div>
        </div>
        <div class="error-msg" v-if="showValidationErrors && !$v.name.required">You name is required.</div>

        <div class="input-group">
            <div class="input-wrapper-lg">
                <label for="buy-now-email">Your Email</label>
                <input id="buy-now-email" type="text" v-model.lazy="$v.email.$model" :class="validationStatus($v.email)" :readonly="!!presetEmail">
            </div>
        </div>
        <div class="error-msg" v-if="showValidationErrors && !$v.email.required">Email is required.</div>
        <div class="error-msg" v-if="showValidationErrors && $v.email.required && !$v.email.email">Email is invalid.</div>
        <div class="error-msg" v-if="emailAlreadyTaken">This email is associated with an existing account.<br>Please login so your purchase will be retained in your history.</div>

        <billing-form
                :stripe-publishable-key="stripePublishableKey"
                v-on:tokenRetrieved="onStripeTokenRetrieved"
                v-on:userDataRetrieved="onStripeTokenRetrieved"
                ref="billingForm"
        />
    </form>
</template>

<script>
    import BillingForm from './form-billing.vue';
    import { validationMixin } from 'vuelidate';
    import { required, requiredIf, email } from 'vuelidate/lib/validators';

    export default {
        components: {
            BillingForm
        },
        mixins: [
            validationMixin
        ],
        props: {
            stripePublishableKey: String,
            includeShipping: Boolean,
            presetEmail: {
                type: String,
                default: null
            }
        },
        data: function() {
            return  {
                name: undefined,
                email: undefined,
                stripeTokenId: undefined,
                showValidationErrors: false,
                emailAlreadyTaken: false
            }
        },
        validations: {
            name: {
                required
            },
            email: {
                required,
                email
            }
        },
        methods: {
            validationStatus(validation) {
                return {
                    'input-error': validation.$error,
                    dirty: validation.$dirty
                }
            },
            validate() {
                if(!this.stripeTokenId) {
                    this.$refs.billingForm.getStripeTokenId();
                    return;
                }

                if (!this.isFormValid()) {
                    return;
                }

                this.verifyEmail();
            },
            verifyEmail() {
                this.emailAlreadyTaken = false;

                if(this.presetEmail) {
                    this.submit();
                    return;
                }

                this.$api.post('v1/accounts/verify_email', { email: this.email })
                    .then(res => this.submit())
                    .catch(err => this.emailAlreadyTaken = true);
            },
            submit() {
                this.$emit('submit', {
                    name: this.name,
                    email: this.email,
                    stripeTokenId: this.stripeTokenId
                });
            },
            onStripeTokenRetrieved(stripeTokenId) {
                this.stripeTokenId = stripeTokenId;
                this.validate();
            },
            isFormValid() {
                this.$v.$touch();
                this.showValidationErrors = true;
                return !this.$v.$anyError;
            },
        },
        mounted() {
            if (this.presetEmail) {
                this.email = this.presetEmail;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/_variables_home.scss";
    @import "../../styles/common_home.scss";
    @import "../../styles/form_home.scss";

    @media only screen and (max-width: $max-mobile-sm-width) {
    }
</style>
